import React from "react";

const Footer = () => (
  <footer className="bg-gray-900 text-white py-6 text-center">
    <p>&copy; {new Date().getFullYear()} Stackness. Built by Muhammad Shoaib.</p>
    <p className="text-sm mt-2">
      GitHub: <a href="https://github.com/Muhammad-Shoaib-001" className="underline">Muhammad Shoaib</a>
    </p>
  </footer>
);

export default Footer;
